module.exports = __webpack_public_path__ + "img/lQLPJxZbP5bs7s_NAjrNAqCwKzWiM7tY0yAClpFThkCdAQ_672_570.99f82bfd.png";